// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class PositionValueGroup extends PFixFieldSet {
    get isRemoved() {
        return super.GetValue(FieldsFactory.FIELD_IS_REMOVED);
    }
    get routeId() {
        return super.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    get instrumentTypeId() {
        return super.GetValue(FieldsFactory.FIELD_INSTRUMENTTYPE_ID);
    }
    get productType() {
        return super.GetValue(FieldsFactory.FIELD_PRODUCT_TYPE);
    }
    get currentPositionValuePerInstrumentGroup() {
        return super.GetValue(FieldsFactory.FIELD_CURRENT_POSITION_VALUE_PER_INSTRUMENT_GROUP);
    }
    get currentPositionValuePerSuperGroup() {
        return super.GetValue(FieldsFactory.FIELD_CURRENT_POSITION_VALUE_PER_SUPER_GROUP);
    }
    get relativePositionValuePerInstrumentGroup() {
        return super.GetValue(FieldsFactory.FIELD_RELATIVE_POSITION_VALUE_PER_INSTRUMENT_GROUP);
    }
    get relativePositionValuePerSuperGroup() {
        return super.GetValue(FieldsFactory.FIELD_RELATIVE_POSITION_VALUE_PER_SUPER_GROUP);
    }
    constructor(pfixFieldSet) {
        super(FieldsFactory.POSITION_VALUE_GROUP, null, pfixFieldSet);
    }
}
